<template>
    <el-row ref="productRow">
        <el-col :span="12">
            <el-button type="primary" size="small" @click="addProductsOpen" 
            v-if="isBatch" class="mb15">
                <i class="fa fa-plus"></i>&nbsp;批量添加
            </el-button>
            <el-button type="primary" size="small" @click="create" v-if="isAdd" class="mb15">
                <i class="fa fa-plus"></i>&nbsp;添 加
            </el-button>
            <el-button :disabled="deleteList.length < 1" size="small" 
            @click="deleteProduct(deleteList)" v-if="isDelete" class="mb15">
                <i class="fa fa-trash"></i>&nbsp;删 除
            </el-button>
            <el-button 
                :disabled="deleteList.length < 1" 
                size="small" 
                @click="copyProduct(deleteList)" 
                :loading="copyLoading"
                v-if="isCopy">
                    <i class="fa fa-copy" v-if="!copyLoading"></i>&nbsp;复 制
            </el-button>
            <!-- 2020-07-26 @author zjs start -->
            <el-button type="primary" size="small" @click="addQuoteOpen" v-if="isQuote" class="mb15">
                <i class="fa fa-plus"></i>&nbsp;引用销售单据
            </el-button>
            <!-- 2020-07-26 @author zjs  end  -->
        </el-col>
        <el-col :span="12" class="tr">
        </el-col>
        <el-col :span="24">
            <el-table
                :data="productList"
                :style="{width: dropdownWidth, margin: 0}"
                @select="handleSelectionChange"
                @select-all="handleSelectionChange"
                v-item-ref
                ref="table">
                <!-- 多选框 start -->
                <template v-if="isDelete">
                    <el-table-column
                        type="selection"
                        width="45">
                    </el-table-column>
                </template>
                <!-- 多选框 end -->
                
                <!-- 序号 start -->
                <el-table-column
                    type="index"
                    width="35">
                </el-table-column>
                <!-- 序号  end -->
                <!-- 此列用于指令绑定，监听每行数据的变化 start -->
                <el-table-column
                    width="1">
                    <template slot-scope="scope">
                       <input type="hidden" :data-index="scope.$index" v-item-ref="scope.column">
                    </template>
                </el-table-column>
                <!-- 此列用于指令绑定，监听每行数据的变化 end -->
                <!-- 遍历配置识别 start -->
                <template v-for="(el, index) in theadConfig">
                <template  v-if="!el.type || el.type != 'function'">
                    <el-table-column
                        :key="'pro_tab_'+ index"
                        :width="el.width > 0 ? el.width : null"
                        :label="el.label">
                        <template slot-scope="scope" >
                            <!-- 货品录入组件 start -->
                            <template v-if="el.component == 'LyAutoProduct'">
                                <ly-auto-product 
                                    v-model="scope.row[el.prop]"
                                    :placeholder="el.label"
                                    :json="el.json"
                                    :store-id="other.warehouse_id"
                                    @count="countFn"
                                    @keydown.native="handleKeydown($event, scope)">  
                                </ly-auto-product>
                            </template>
                            <!-- 货品录入组件 end --> 
                            <!-- 带搜索的输入框组件 start -->
                            <template v-else-if="el.component == 'LyAutoSearch'">
                                <ly-auto-search 
                                    v-model="scope.row[el.prop]"
                                    width="100%"
                                    :placeholder="el.label"
                                    :is-init-search="el.isInitSearch"
                                    :dropdown-width="(el.json && el.json.width) ? el.json.width : dropdownWidth"
                                    :json="el.json"
                                    @count="countFn"
                                    @keydown.native="handleKeydown($event, scope)">  
                                </ly-auto-search>
                            </template>
                            <!-- 带搜索的输入框组件 end --> 
                            <!-- 时间组件 start -->
                            <template v-else-if="el.component == 'LyDatePicker'">
                                <!-- 对象型的绑定 start -->
                                <template v-if="el.json && el.json.prop && el.json.prop.length > 0">
                                    <ly-date-picker 
                                        v-model="scope.row[el.prop][el.json.prop]" 
                                        size="small"
                                        :is-today="el.json.isToday"
                                        :disabled="(el.json && el.json.disabled) ? el.json.disabled : false"
                                        :type="(el.json && el.json.type) ? el.json.type : 'daterange'"
                                        :is-distinguish="true"
                                        @keydown.native="handleKeydown($event, scope)">
                                    </ly-date-picker>
                                </template>
                                <!-- 对象型的绑定 end -->
                                <template v-else>
                                    <ly-date-picker 
                                        v-model="scope.row[el.prop]" 
                                        size="small"
                                        :disabled="(el.json && el.json.disabled) ? el.json.disabled : false"
                                        :type="(el.json && el.json.type) ? el.json.type : 'daterange'"
                                        :is-distinguish="true"
                                        @keydown.native="handleKeydown($event, scope)">
                                    </ly-date-picker>
                                </template>
                            </template>
                            <!-- 时间组件 end -->
                            <!-- 普通输入框 start -->
                            <template v-else-if="el.component == 'ElInput'">
                                <template v-if="el.json && el.json.prop && el.json.prop.length > 0">
                                    <el-input 
                                        v-model="scope.row[el.prop][el.json.prop]"
                                        size="small" 
                                        :placeholder="el.label"
                                        :disabled="el.json && el.json.disabled ? el.json.disabled : false" 
                                        @keydown.native="handleKeydown($event, scope)">
                                        <!-- @keydown.up.native.prevent="keydownFn(-1, scope)"
                                        @keydown.down.native.prevent="keydownFn(1, scope)" -->
                                    </el-input>  
                                </template>
                                <template v-else>
                                    <el-input 
                                        v-model="scope.row[el.prop]"
                                        size="small" 
                                        :placeholder="el.label"
                                        :disabled="el.json && el.json.disabled ? el.json.disabled : false"
                                        @keydown.native="handleKeydown($event, scope)">
                                        <!-- @keydown.up.native.prevent="keydownFn(-1, scope)"
                                        @keydown.down.native.prevent="keydownFn(1, scope)" -->
                                    </el-input>  
                                </template>
                            </template>
                            <!-- 普通输入框 end -->
                            <!-- 拉下选择器 start -->
                            <template v-else-if="el.component == 'LySelect'">
                                <ly-select 
                                    :api="el.json.api || ''" 
                                    :def-data="el.json.data || []"
                                    :all="el.json.all" 
                                    :def-one="el.json.defOne"
                                    :bind-obj="el.json.bindObj"
                                    :watch-field="scope.row[el.json.watch]"
                                    v-model="scope.row[el.prop]">
                                </ly-select>
                            </template>
                            <!-- 拉下选择器 end -->
                            <!-- 数字输入 start -->
                             <template v-else-if="el.component == 'LyInputNumber'">
                                <ly-input-number 
                                    v-model="scope.row[el.prop]"
                                    :min="(el.json && el.json.min) || 0"
                                    :placeholder="el.label"
                                    :disabled="scope.row['disabled'] ? scope.row['disabled'].indexOf(el.prop) != -1 : false"
                                    size="small"
                                    @keydown.native="handleKeydown($event, scope)">
                                </ly-input-number>
                            </template>
                            <!-- 数字输入 end -->
                            <!-- InputNumber 计数器 start -->
                            <!-- 2017-12-18 修改，将el-input-number 改为 ly-input-number 因为输入小数和负数不好用 -->
                            <template v-else-if="el.component == 'ElInputNumber'">
                                <template v-if="el.json && el.json.prop && el.json.prop.length > 0">
                                    <!-- <el-input-number 
                                        v-model="scope.row[el.prop][el.json.prop]" 
                                        size="small"
                                        :debounce="3000">
                                    </el-input-number> -->
                                    <ly-input-number 
                                        v-model="scope.row[el.prop][el.json.prop]"
                                        :placeholder="el.label"
                                        size="small"
                                        @keydown.native="handleKeydown($event, scope)">
                                    </ly-input-number>
                                </template> 
                                <template v-else>
                                    <ly-input-number 
                                        v-model="scope.row[el.prop]"
                                        :placeholder="el.label"
                                        size="small"
                                        @keydown.native="handleKeydown($event, scope)">
                                    </ly-input-number>
                                  <!--   <el-input-number 
                                        v-model="scope.row[el.prop]" 
                                        size="small"
                                        :debounce="3000">
                                    </el-input-number>  -->
                                </template>
                            </template>
                            <!-- InputNumber 计数器 end  -->
                            <!-- 调账单据 start -->
                            <!-- 此组件，依赖外部传入的参数，此些参数都需要提前知道 -->
                            <template v-else-if="el.component == 'LyAdjustOrder'">
                                <ly-adjust-order
                                    :product-id="scope.row['product']['product_id']"
                                    :warehouse-id="other.warehouse_id"
                                    :providerId="other.provider.provider_id"
                                    :date-start="other.date_start"
                                    :date-end="other.date_end"
                                    :is-fengcang="other.warehouse_id ? true : false"
                                    v-model="scope.row[el.prop]">
                                </ly-adjust-order>
                            </template>
                            <!-- 调账单据  end  -->                            
                            <!-- 自动搜索绑定值的输入框 start -->
                            <template v-else-if="el.component == 'LyQueryInput'">
                                <ly-query-input
                                    v-model="scope.row[el.prop]"
                                    :width="el.width"
                                    :json="el.json"
                                    :placeholder="el.name"
                                    :watch-field="scope.row[el.json.watch]"
                                    :disabled="el.json && el.json.disabled ? el.json.disabled : false"
                                    @keydown.native="handleKeydown($event, scope)">
                                </ly-query-input>
                            </template>
                            <!-- 自动搜索绑定值的输入框 end -->                            
                            <!-- 一层绑定的输入框搜索 start -->
                            <template v-else-if="el.component == 'LyAutoSelect'">
                                <ly-auto-select 
                                    v-model="scope.row[el.prop]"
                                    :width="el.width || null"
                                    :json="el.json"
                                    :watch-field="scope.row[el.json.watch]">
                                </ly-auto-select>
                            </template>
                            <!-- 一层绑定的输入框搜索  end -->              
                            <!-- 一层绑定的输入框搜索 start -->
                            <template v-else-if="el.component == 'LyAutoText'">
                                <ly-auto-text 
                                    v-model="scope.row[el.prop]"
                                    :json="el.json"
                                    :watch-field="scope.row[el.json.watch]"
                                    :watch-field-two="scope.row[el.json.watch2]">
                                </ly-auto-text>
                            </template>
                            <!-- 一层绑定的输入框搜索  end -->
                            <!-- 普通文字显示 start -->
                            <template v-else>
                                <!-- 对象字段的展示(二维取得) start -->
                                <template v-if="el.json && el.json.prop">
                                    {{scope.row[el.prop][el.json.prop]}}
                                </template>
                                <!-- 对象字段的展示(二维取得) end -->
                                <template v-else>
                                    {{scope.row[el.prop]}}
                                </template>
                            </template>
                            <!-- 普通文字显示  end -->
                        </template>
                    </el-table-column>
                </template>
                </template>
                <!-- 遍历配置识别  end -->
             </el-table>
        </el-col>
        <el-col :span="24">
            <slot></slot>
        </el-col>
        <template v-if="isBatch">
            <batch-input postUrl="api/plproduct" 
                :type="batchType" 
                :warehouse-id="other.warehouse_id ? other.warehouse_id : ''"
                @complete="addProducts" 
                ref="batchinput"></batch-input>
        </template>
        <ly-quote-bill ref="quote" v-if="isQuote" @change="quoteChange"></ly-quote-bill>
    </el-row>   
</template>
<script>
    /**
     * 货品录入组件
     * @author zjs
     * @time 2017-09-14
     */
    import Product from './product'
    import LyAutoProduct from '@c/auto-product'
    // @time 2017-9-14 welpher 添加批量添加组件
    import {TGBatchInput as BatchInput} from '@c/batchinput'
    import LyAutoSearch from '@c/auto-search'
    import LySelect from '@c/select'
    import LyDatePicker from '@c/date_picker'
    import LyInputNumber from '@c/input-number'
    // 调账单据
    import LyAdjustOrder from '@c/adjust-order'
    import LyQueryInput from '@c/query-input'
    import LyAutoSelect from '@c/auto-select'
    import LyAutoText from '@c/auto-text'
    import LyQuoteBill from '@c/quote-bill'

    export default {
        name: 'LyProductTable',
        mixins: [Product],
        components: {
            LyAutoProduct,
            BatchInput,
            LyAutoSearch,
            LySelect,
            LyDatePicker,
            LyInputNumber,
            LyAdjustOrder,
            LyQueryInput,
            LyAutoSelect,
            LyAutoText,
            LyQuoteBill
        },
        props: {
            theadConfig: {
                type: Array, // 表格组件的配置
                default: () => []
            },
            value: { // 用于v-model绑定的值
                type:Array,
                default: () => []
            },
            isDelete: { // 是否有删除功能
                type: Boolean,
                default: true
            },
            isCopy: { // 是否有拷贝功能
                type: Boolean,
                default: true
            },
            isAdd: { // 是否有新增功能
                type: Boolean,
                default: true
            },
            isBatch: { // 是否有批量添加功能
                type: Boolean,
                default: false
            },
            isQuote: { // 2020-07-17 zjs 是否有引用单据
                type: Boolean,
                default: false
            },
            batchType: {
                type: String,
                default: ''
            }, // 批量添加的类型
            other: {
                type: Object,
                default: function () {
                    return {}
                }
            }, // 额外的参数，因为不确定字段，就传入一个包装的对象
            isDirective: {
                type: Boolean,
                default: true
            } // 标识是否知晓
        },
        data () {
            return {
                copyLoading: false,
                dropdownWidth: '', // 提示面板的宽度
                timerspace: 0 ,// 时间间隔的记录
                timer: null, // 定时器对象
                count: 0,
                colFetchCount: 0, // 单元格中联想查询出来的数据个数
                isCountFnFirst: false // 标识是否先执行了countFn函数
            }
        },
        created () {
            this.initProductField()
            this.keydownFn()
        },
        mounted () {
            this.dropdownWidth = this.$refs['productRow'].$vnode.elm.clientWidth + 'px'
            this.pushProductInArr(this.value)
        },
        // updated () {
        //     this.$nextTick(() => {
        //         console.log('tb list:',this.productList)
        //     })
        // },
        methods:{
            /**
             * 键盘按下的监听
             */
            handleKeydown (e, scope) {
                switch (e.keyCode) {
                    // 左右键的处理
                    case 37:
                        if (e.target.selectionStart <= 0) {
                            this.leftRightKeydown(-1, scope)
                        }
                        break;
                    case 39: 
                        let value = e.target.value
                        if (e.target.selectionStart >= value.length) {
                            this.leftRightKeydown(1, scope)
                        }
                        break;
                    case 38: // 上键
                        this.keydownFn(-1, scope)
                        break;
                    case 40: // 下键
                        this.keydownFn(1, scope)
                        break;
                }
            },
            /**
             * 联想输入框的数据数量
             */
            countFn (count) {
                this.colFetchCount = count
                this.isCountFnFirst = true
            },
            /**
             * 输入框键盘按下的监听
             * @param incre 增量
             * @param scope 当前行数据信息
             */
            keydownFn (incre, scope) {
                if (!scope) return
                if (!this.isCountFnFirst) {
                    this.colFetchCount = 0
                }
                this.isCountFnFirst = false
                let index = scope.$index
                if (index >= 0 && this.colFetchCount <= 0) {
                    // 获得tbody下面的tr
                    let trArr = this.$refs.table.$el.querySelectorAll('tr.el-table__row')
                    // 根据上下键，增量索引
                    index += incre
                    if (index >= 0 && index < trArr.length) {
                        // 取得对应行节点
                        let trEl = trArr[index] 
                        // 取得对输入框
                        let inputEl = trEl.querySelector('td.' + scope.column.id + ' input')
                        // 设置输入框的选中
                        inputEl && inputEl.focus()
                    }
                }
            },
            /**
             * 左右键的处理
             * @param incre 增量
             * @param scope 当前行数据信息
             */
            leftRightKeydown (incre, scope) {
                if (!scope) return
                // 根据增量计算ID
                let str = scope.column.id.split('_')
                let lastIndex = str.length - 1
                let no = parseInt(str[lastIndex]) + incre
                // 获得当前行对象
                let trEl = this.$refs.table.$el.querySelectorAll('tr.el-table__row')[scope.$index]
                // 寻找相邻的input，直到找不到Td
                let isWhile = true
                while (isWhile) {
                    str[lastIndex] = no
                    // 查找列对象
                    let tdEl = trEl.querySelector('td.' + str.join('_'))
                    if (tdEl) {
                        let inputEl = tdEl.querySelector('input')
                        if (inputEl) {
                            inputEl.focus()
                            isWhile = false
                        } else {
                            no += incre
                        }
                    } else {
                        isWhile = false
                    }
                }
            },
            /**
             * 批量添回商器
             * @author welpher
             */
            addProducts (value) {
                this.pushProductInArr(value, true)
            },
            /**
             * 打开批量添加商品
             * @author welpher
             * 
             */
            addProductsOpen () {
                this.$refs['batchinput'].show()
            },
            /** 
             * 将货品列表中的货品，添加列表中
             * @param isDiff 为true时为纯货品
             */
            pushProductInArr (arr, isDiff) {
                if (arr && arr.length > 0) {
                    arr.forEach((el) => {
                        if (isDiff) {
                            this.pushProduct({product: el})
                        } else {
                            this.pushProduct(el)
                        }
                    })
                }
            },
            /**
             * 替换当前货品列表
             * @param  {[type]} arr [description]
             * @return {[type]}     [description]
             */
            replaceProductList (arr) {
                this.resetList()
                if (arr && arr.length > 0) {
                    arr.forEach((el) => {
                        this.pushProduct(el)
                    })
                }
                this.$emit('input', this.productList)
            },
            /**
             * 重置货品列表
             * @return {[type]} [description]
             */
            resetList () {
                this.productList.splice(0, this.productList.length)
            },
            /**
             * 拷贝选中的项
             */
            copyProduct (list) {
                this.copyLoading = true
                this.pushProductInArr(list)
                setTimeout(() => {
                    this.copyLoading = false
                }, 500)
            },
            /**
             * 打开引用单据弹窗
             */
            addQuoteOpen () {
                let customer = this.other.customer
                if (customer.customer_id) {
                    this.$refs['quote'].open(customer.customer_id)
                } else {
                    this.$message({
                        message: '请先选择客户',
                        type: 'warning'
                    });
                }
            },
            quoteChange (val) {
                val.forEach(el => {
                    this.pushProduct(el)
                })
            }
        },
        // 指令
        directives : {
            'item-ref' : { // 商品列表项目，对象中的值发生变化时触发
                deep : true,
                update : function (el, binding, vnode) {
                    if (!vnode.context.isDirective) {
                        return 
                    }
                    // 2018-06-28添加，在调用函数设置一个回调，在回调完成之前，不往下执行，
                    // 不然函数中改变了值，指令会一直执行
                    if (vnode.context.inFuncCallback) {
                        return
                    }
                    let now = new Date().getTime()
                    // el-table中，每行都在触发此指令
                    if (now - vnode.context.timerspace > 200) { // 避免高频率的触发
                        // 清除定时器
                        if (vnode.context.timer) {
                            clearTimeout(vnode.context.timer)
                        }
                        // 配置中的函数调用
                        // 这里延时调用，避免指令多次触发的重复调用
                        vnode.context.timer = setTimeout(function () {
                            // 设置已经进入函数的回调中
                            // 这里仍然有问题，不能执行多个函数的状态处理，只能是一个函数的
                            // 先这样吧 2018-06-28记录
                            vnode.context.inFuncCallback = true
                            vnode.context.functionList.forEach(function (func) {
                                // 调用函数后，回调中延时执行状态的变更，避免多次触发
                                func(vnode.context.productList, () => {
                                    setTimeout(() => {
                                        vnode.context.inFuncCallback = false
                                    }, 500)
                                })
                            })
                        }, 500)
                        // 获得当前商品筛选组件，所在的索引
                        vnode.context.timerspace = now
                        vnode.context.$emit('input', vnode.context.productList)
                    }
                }
            }
        }
    }
</script>